module.exports = __webpack_public_path__ + "static/media/md-shirt.0fa56aee.svg";